export default __webpack_public_path__ + "static/media/330_portfolio03-fr-web.0fa9b600.png";